import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/Cloud';

class CloudIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default CloudIcon;
